import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { connectGoogleCallback } from "../lib/api";
import { Alert, Icon } from "../design/ui";

export function GoogleCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"connecting" | "success" | "error">("connecting");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const didRun = useRef(false);

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;

    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const errorParam = searchParams.get("error");

    if (errorParam) {
      setError(`Google denied the connection: ${errorParam}`);
      setStatus("error");
      return;
    }

    if (!code || !state) {
      setError("Invalid callback URL. Did you arrive here from Google?");
      setStatus("error");
      return;
    }

    connectGoogleCallback(code, state)
      .then((result) => {
        setEmail(result.email);
        setStatus("success");
        setTimeout(() => navigate("/settings"), 2000);
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : "Connection failed");
        setStatus("error");
      });
  }, [searchParams, navigate]);

  if (status === "connecting") {
    return (
      <div className="kt-center">
        <span className="kt-spinner" />
        <span>Connecting your Gmail account…</span>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className="kt-center">
        <Icon name="circle-check" size={40} color="var(--kt-teal)" />
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Connected!</h2>
        <p style={{ color: "var(--kt-text-secondary)", textAlign: "center" }}>
          <span style={{ color: "var(--kt-ink)", fontWeight: 500 }}>{email}</span> is now linked to your brain.
        </p>
        <p style={{ color: "var(--kt-text-muted)", fontSize: 13 }}>Redirecting to settings…</p>
      </div>
    );
  }

  return (
    <div className="kt-center">
      <Alert tone="danger">{error}</Alert>
      <Link to="/settings" style={{ color: "var(--kt-teal-ink)", fontSize: 13 }}>
        Back to settings
      </Link>
    </div>
  );
}
